import {
  prepareCategoryFilters,
  prepareLocationFilters,
  prepareRoomsFilters,
  prepareStatusFilters,
} from './prepareFilters';
import { prepareOffers } from './prepareOffers';
import { IOffersHistoryListingData } from 'shared/types/offersHistory';
import { TGetHouseOfferHistoryDesktopResponse_1 } from 'shared/repositories/valuation-offer-history/v4/get-house-offer-history-desktop';

export const prepareOffersHistory = (response: TGetHouseOfferHistoryDesktopResponse_1): IOffersHistoryListingData => {
  const offers: IOffersHistoryListingData['offers'] = prepareOffers(response.offers);
  const statusFilters = prepareStatusFilters(response.statusCounts);
  const roomsFilters = prepareRoomsFilters(response.roomCounts);
  const locationFilters = prepareLocationFilters(response.locations);
  const categoriesFilters = prepareCategoryFilters(response.categories);

  return {
    offers,
    roomsFilters,
    statusFilters,
    locationFilters,
    totalCount: response.totalCount,
    activeFiltersValues: response.activeFiltersValues,
    categoriesFilters,
  };
};
